module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("S.M.")]), _vm._v(" "), _c('p', [_vm._v("We endured hell together, and since we’ve both left, I know I can do anything with you in my corner… I now have three published books and multiple film projects as proof. I love you.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("J.W.M.")]), _vm._v(" "), _c('p', [_vm._v("We both know that Mamie would haunt me if I didn’t mention your incredible impact on my life, both creatively and personally. My best friend. No matter what happens, I’ve got your back.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("To the entire team at Austin Macauley Publishers, thank you once again for making my dream a reality while ensuring the process is as smooth as possible.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0